import { assignSafe } from '@summit/core';

export class FilterParameter {
  id: string;
  description?: string; // Leave empty if you want to hide.
  state: boolean;
  oDataFilter?: string;
  filterData?: any;
  dynamic?: boolean;

  constructor(jsonData?: Partial<FilterParameter>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    //this.state ??= false; //no hard false since this will break views overlays
    if (this.id === 'employeeID') this.filterData ??= '<SELF>'; //default to self
  }

  static ToTuple(input: FilterParameter[]): [string, string][] {
    const response = new Array<any>();
    input.forEach((element) => {
      const newEntry = {} as any;
      newEntry['id'] = element.id;
      newEntry['value'] = element.state.toString();
      response.push(newEntry);
    });
    return response;
  }
  static ToStateOnly(input: FilterParameter[]): Partial<FilterParameter>[] | undefined {
    //console.log('FilterParameters ToObject Inputs', input);
    if (input == null || input == undefined) {
      return undefined;
    }
    return input.map((element) => {
      return { id: element.id, state: element.state };
    });
  }

  static AreTheSameFilterValue(input1: FilterParameter, input2: FilterParameter) {
    return (
      (input1 == null && input2 == null) ||
      (input1 == undefined && input2 == undefined) ||
      (input1?.id == input2?.id &&
        input1?.state == input2?.state &&
        JSON.stringify(input1?.filterData) == JSON.stringify(input2?.filterData))
    );
  }
}
